import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './assets/lang/i18n'

import './assets/css/index.scss'


import 'animate.css';//引入动画效果


const app = createApp(App);
app.use(i18n);
app.use(store);
app.use(router);
app.mount('#app');
// createApp(App).use(i18n).use(store).use(router).mount('#app')
